import React, {useEffect, useLayoutEffect, useRef, useState} from "react"
import Image from "../rest/Image";
import ReactCrop, {makeAspectCrop, centerCrop, convertToPixelCrop} from "react-image-crop";
import {Button} from "@vkontakte/vkui";
import {MdOutlineCropRotate} from "react-icons/md";
import {AiOutlineCloseCircle} from "react-icons/ai";
import {printCropAspectForImg} from "../utils/printCropAspect";

const aspectFromProps = (imageSize, selectedSize, rotate) => {
    if (!imageSize || !selectedSize) {
        return 1;
    }
    return printCropAspectForImg(selectedSize, imageSize.width, imageSize.height, rotate);
};

const CropImage = ({file, hidden, dk, cropInit, imageSize, selectedSize, rotate = false, modalNaturalSwap = false, closePop, savePop}) => {
    const [crop, setCrop] = useState()
    const [cropAll, setAllCrop] = useState()
    const [aspect, setAspect] = useState(() => aspectFromProps(imageSize, selectedSize, rotate))
    const [modalRotateToggled, setModalRotateToggled] = useState(() => modalNaturalSwap);
    const imgRef = useRef();
    const imgBootstrappedRef = useRef(false);

    const previewCanvas = (canvas, cropPixels) => {
        const c = cropPixels ?? cropAll;
        if (!imgRef.current || !c || !canvas) {
            return;
        }
        const ctx = canvas.getContext('2d')
        const lay = Image.getCropLayoutSize(imgRef.current);
        const dispW = lay.width > 0 ? lay.width : imgRef.current.width;
        const dispH = lay.height > 0 ? lay.height : imgRef.current.height;
        const scaleX = imgRef.current.naturalWidth / dispW
        const scaleY = imgRef.current.naturalHeight / dispH

        ctx.fillStyle = "yellow";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.imageSmoothingQuality = 'high'
        const cropX = (c.hasOwnProperty("x") ? c.x : 0) * scaleX
        const cropY = (c.hasOwnProperty("y") ? c.y : 0) * scaleY

        const cropWidth = c.width
        const cropHeight = c.height

        const srcW = cropWidth * scaleX
        const srcH = cropHeight * scaleY

        ctx.canvas.width = Math.max(1, Math.round(srcW));
        ctx.canvas.height = Math.max(1, Math.round(srcH));

        ctx.drawImage(imgRef.current, cropX, cropY, srcW, srcH, 0, 0, canvas.width, canvas.height)

    }

    const saveMe = (cropPercentOverride, cropPixelsOverride, metaOverride) => {
        const cPx = cropPixelsOverride !== undefined ? cropPixelsOverride : cropAll;
        if (!cPx) {
            return;
        }
        const canvas = document.querySelector(`.result_canvas_${dk}`);
        if (!canvas) {
            return;
        }
        previewCanvas(canvas, cPx);
        const cPercent = cropPercentOverride !== undefined ? cropPercentOverride : crop;
        const meta =
            metaOverride !== undefined && metaOverride !== null
                ? metaOverride
                : {modalNaturalSwap: modalRotateToggled};
        savePop(cPercent || cPx, imgRef, meta);
    }

    const onImageLoad = (e) => {
        if (imgBootstrappedRef.current) {
            return;
        }
        if (!selectedSize) {
            return;
        }
        setModalRotateToggled(modalNaturalSwap);
        imgBootstrappedRef.current = true;
        const el = e.currentTarget;
        imgRef.current = el;
        const lay = Image.getCropLayoutSize(el);
        const layoutW = lay.width > 0 ? lay.width : el.width;
        const layoutH = lay.height > 0 ? lay.height : el.height;
        let aspectForPx;

        let crop_percent;
        if (!cropInit) {
            aspectForPx = printCropAspectForImg(selectedSize, el.naturalWidth, el.naturalHeight, rotate);
            crop_percent = centerCrop(
                makeAspectCrop(
                    {
                        unit: '%',
                        width: 100,
                    },
                    aspectForPx,
                    layoutW,
                    layoutH
                ),
                layoutW,
                layoutH
            )

            setCrop(crop_percent)
            setAspect(aspectForPx)
        } else {
            crop_percent = cropInit;
            setCrop(crop_percent)
            /* Не по layout (w>=h): при узком модальном боксе это ломало aspect и ориентацию рамки при редактировании. */
            aspectForPx = printCropAspectForImg(selectedSize, el.naturalWidth, el.naturalHeight, rotate);
            setAspect(aspectForPx)
        }

        let crop_px;
        if (!cropInit) {
            crop_px = centerCrop(
                makeAspectCrop(
                    {
                        unit: 'px',
                        width: layoutW,
                    },
                    aspectForPx,
                    layoutW,
                    layoutH
                ),
                layoutW,
                layoutH
            );
        } else {
            try {
                crop_px =
                    cropInit.unit === "px" && cropInit.width > 0
                        ? {...cropInit, unit: "px"}
                        : convertToPixelCrop(cropInit, layoutW, layoutH);
            } catch (err) {
                crop_px = centerCrop(
                    makeAspectCrop(
                        {
                            unit: 'px',
                            width: layoutW,
                        },
                        aspectForPx,
                        layoutW,
                        layoutH
                    ),
                    layoutW,
                    layoutH
                );
            }
        }
        setAllCrop(crop_px);
        const resultCanvas = document.querySelector(`.result_canvas_${dk}`);
        if (resultCanvas) {
            Image.cropCanvas(resultCanvas, imgRef, crop_px)
        }
        if (!hidden) {
            savePop(crop_percent || cropInit || crop_px, imgRef, {modalNaturalSwap: modalNaturalSwap});
        }

    }

    const displaySrc =
        file && file.photo ? Image.getDisplayUrl(file.photo, file.previewThumb) : "";

    useLayoutEffect(() => {
        imgBootstrappedRef.current = false;
        const el = imgRef.current;
        if (el && el.complete && el.naturalWidth > 0 && selectedSize) {
            onImageLoad({currentTarget: el});
        }
    }, [displaySrc, selectedSize, rotate, imageSize && imageSize.width, imageSize && imageSize.height, modalNaturalSwap]);

    useEffect(() => {
        if (!cropAll || !hidden) {
            return;
        }
        saveMe();
        closePop(dk);
    }, [cropAll, hidden])

    const rotateCrop = () => {
        /* Не требуем cropAll: рамка считается из imgRef; cropAll мог обнулиться из‑за лишнего onComplete после первого поворота. */
        if (!imgRef.current || !selectedSize) {
            return;
        }
        const lay = Image.getCropLayoutSize(imgRef.current);
        const layoutW = lay.width > 0 ? lay.width : imgRef.current.width;
        const layoutH = lay.height > 0 ? lay.height : imgRef.current.height;
        const nw = imgRef.current.naturalWidth;
        const nh = imgRef.current.naturalHeight;
        /* Переключаем ориентацию рамки туда/обратно внутри модалки независимо от глобального rotate файла. */
        const nextToggle = !modalRotateToggled;
        const baseW = nextToggle ? nh : nw;
        const baseH = nextToggle ? nw : nh;
        const aspectRot = printCropAspectForImg(selectedSize, baseW, baseH, rotate);
        const cropd = centerCrop(
            makeAspectCrop(
                {
                    unit: '%',
                    width: 100,
                },
                aspectRot,
                layoutW,
                layoutH
            ),
            layoutW,
            layoutH
        )
        const crop_px = centerCrop(
            makeAspectCrop(
                {
                    unit: 'px',
                    width: layoutW,
                },
                aspectRot,
                layoutW,
                layoutH
            ),
            layoutW,
            layoutH
        )
        setCrop(cropd)
        setAllCrop(crop_px)
        setAspect(aspectRot)
        setModalRotateToggled(nextToggle);
        saveMe(cropd, crop_px, {modalNaturalSwap: nextToggle});
    }
    return (

        <div style={{visibility: hidden ? "hidden" : "visible"}} className={"content image_crop_content"}>
            <div style={{height: 50, padding: 10, width: "95%", display: "flex", justifyContent: "flex-end"}}>
                <button type="button" onClick={() => closePop(dk)} className={"close_cropik"}><AiOutlineCloseCircle color={"red"}
                                                                                                      size={30}/>
                </button>


            </div>
            <ReactCrop keepSelection
                       className={"cropik"} crop={crop}
                       onChange={(_, percentCrop) => {
                           setCrop(percentCrop)
                           savePop(percentCrop, imgRef, {modalNaturalSwap: modalRotateToggled})
                       }}
                       aspect={aspect}
                       onComplete={(c, percentCrop) => {
                           /* Иначе после программного setCrop (кнопка «Повернуть») библиотека может вызвать onComplete с пустым/нулевым кропом и обнулить cropAll — повторный поворот перестаёт работать. */
                           const w = Number(c && c.width);
                           const h = Number(c && c.height);
                           if (!c || !Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
                               return;
                           }
                           setAllCrop(c);
                           if (percentCrop) {
                               savePop(percentCrop, imgRef, {modalNaturalSwap: modalRotateToggled});
                           }
                       }}>
                <img ref={imgRef} crossOrigin="anonymous" onLoad={onImageLoad}
                     src={displaySrc}/>
            </ReactCrop>
            <div className="crop_buttons">
                <Button onClick={() => {
                    saveMe()
                    closePop(dk);
                }} type="button" size={"l"} stretched mode={"commerce"}>Сохранить</Button>
                <Button onClick={rotateCrop} type="button" before={<MdOutlineCropRotate size={25}/>} size={"l"} stretched
                        mode={"secondary"}>Повернуть</Button>
            </div>
        </div>

    )
}
export default CropImage
